import { format, formatDistanceToNow } from 'date-fns';
import moment from 'moment';

export function fDate(date: string) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date: any) {
  return format(new Date(date), 'dd MMM yyyy h:mm a');
}

export function fDateLine(date: any) {
  return format(new Date(date), 'dd/MM/yyyy,');
}

export function fTimeLine(date: any) {
  return format(new Date(date), 'HH:mm:ss');
}

export function fDateTimeSuffix(date: any) {
  return format(new Date(date), 'dd/MM/yyyy HH:mm');
}

export function fToNow(date: any) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}

export const shortWeekday = (weekday: string): string => {
  return weekday.substring(0, 3); // Shorten the weekday to first three letters
};

export const shortMonth = (month: string): string => {
  return moment().month(month).format("MMM"); // Shorten the month to its abbreviation
};

export const formatDate = (date: string) => new Date(date).toLocaleDateString();
export const formatTime = (date: string) => new Date(date).toLocaleTimeString();
export const getMonth = (date: Date) => parseInt(moment(date).format('M'));
export const getYear = (date: Date) => parseInt(moment(date).format('YYYY'));
export const getMonthNameFromNumber = (number: string) =>
  moment(number, 'MM').format('MMM');
export const DateFormat = (date: Date) => new Date(date).toLocaleDateString();

const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' };

export const formatDateAccordingToName = (date: string) => {
  const newDate = new Date(date);
  return newDate.toLocaleDateString(undefined, options);
};


export const parseDateToStartTimestamp = (dateString: string) => {
  return moment(dateString).startOf('day').valueOf();
};

export const parseDateToEndTimestamp = (dateString: string) => {
  return moment(dateString).endOf('day').valueOf();
};